import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <Link to="/" className="back-button">
          <i className="fas fa-arrow-left"></i> 返回首頁
        </Link>

        <div className="policy-header">
          <h1>
            <span role="img" aria-label="lock">
              🔒
            </span>{" "}
            隱私政策
          </h1>
        </div>

        <div className="policy-body">
          <p>
            本網站使用 Facebook 登入功能以簡化會員註冊與登入流程。 當您使用
            Facebook
            登入時，我們可能會取得您的公開個人資料（例如姓名、頭像）以及電子郵件地址（若您同意）。
          </p>

          <p>
            我們僅將上述資料用於帳號識別、登入驗證與服務提供之目的，不會販售、交換或未經授權提供給第三方。
          </p>

          <p>使用者資料將安全儲存，並僅限授權人員存取。</p>

          <p>使用者可隨時透過聯絡我們要求查詢、更正或刪除個人資料。</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
